//TODO pulizia file
import React, { useState, useContext, useEffect} from 'react';
import styled from 'styled-components';

import {OverlayContext} from '../../contexts/OverlayContext';

import {BORDER, OzButton, OzCol, OzRow, OzCard} from "@ozwol/webui";

import HotfoldersService from '../../services/HotfoldersService';

import CardHeaderTitle from '../../components/CardHeaderTitle';
import HealthyWrapper from '../../components/HealthyWrapper';

import {formatError} from '../../helpers';
const Fullscreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 999;

  & > div{
    height: 100vh !important;
  }
`;

const Wrapper = styled.div`
		margin-top: -20px;
		margin-bottom: -20px;
  & iframe{
    width: 100%;
    height: calc(100vh - 130px);
    border: 0px solid ${BORDER};
	
		

  }
`;

const InsiderHotfoldersModalDiagram = ({isHf, title, uuid = null}) => {
  const {removeOverlay} = useContext(OverlayContext);
  const [item, setItem] = useState(null);

  
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
		if(isHf){
			HotfoldersService.adminHotfolderDiagram(uuid).then((response) => {
				setItem(response);
			}).catch((error) => {
				setFetchError(formatError(error));
			});
		}else{
			HotfoldersService.adminProjectDiagram(uuid).then((response) => {
				setItem(response);
			}).catch((error) => {
				setFetchError(formatError(error));
			});
		}
  }, [isHf, uuid]);

  return (
    <Fullscreen>
      
      <HealthyWrapper error={fetchError}>
        <OzCard
          headerLeft={
            <CardHeaderTitle title={title} />
          }
          headerSeparator={true}
          footerLeft={<OzButton variant={"chetwodeblue-o"} onClick={() => removeOverlay("diagram")}>Back</OzButton>}
        >

          <OzRow>
            <OzCol widthmd="12">
              <Wrapper>
              {item ? 
                <iframe title="diagram" srcDoc={item} />
              : null}
              </Wrapper>
            </OzCol>
            
          </OzRow>
          
        
        </OzCard>
      </HealthyWrapper>
    </Fullscreen>
  );

}
export default InsiderHotfoldersModalDiagram;
